export default __webpack_public_path__ + "static/media/ripple.1f6b22e5.gif";